<template>
    <div>
        <wt-table :labels="receiptTableLabels" :list="invoiceList">
            <template slot="before">
            <el-table-column label="发票申请流水号">
                <template slot-scope="scope">
                    {{scope.row.request&&scope.row.request.requestId}}
                </template>
            </el-table-column>
            <el-table-column label="发票号">
                  <template slot-scope="scope">
                    {{scope.row.request&&scope.row.request.number}}
                </template>
            </el-table-column>
             <el-table-column label="发票抬头">
                  <template slot-scope="scope" v-if="scope.row.information">
                    {{scope.row.information.title}}
                    <div v-if="scope.row.information.titleType==='COMPANY'">
                        {{scope.row.information.identityNumber}}
                    </div>
                </template>
            </el-table-column>
            </template>
            <template>
                <el-table-column :label="invoiceForm==='PAPER'?'发票邮寄信息':'发票接收邮箱'">
                    <template slot-scope="scope">
                        <template v-if="invoiceForm==='PAPER'">
                        <div>{{scope.row.contacts}}</div>
                        <div>{{scope.row.phone}}</div>
                        <div>{{invoiceAdress(scope.row)}}</div>
                        </template>
                        <template v-else>{{scope.row.receiver&&scope.row.receiver.email}}</template>
                    </template>
                </el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" @click="download(scope.row)" v-if="isDownload(scope.row)">下载发票</el-button>
                </template>
            </el-table-column>
            </template>
        </wt-table>
    </div>
</template>
<script>
export default {
  props: {
    receiptTableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    invoiceList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    invoiceForm () {
      return this.invoiceList && this.invoiceList[0] && this.invoiceList[0].information && this.invoiceList[0].information.invoiceForm
    }
  },
  methods: {
    // 是否需要显示下载按钮
    isDownload (row) {
      return row.state === 'VALID' && row.information && row.information.invoiceForm === 'ELECTRONIC'
    },
    download (row) {
      // 下载发票的时候使用的是订单id
      this.$emit('downloadInvoice')
    },
    invoiceAdress (row) {
      return row.provinceName || row.cityName || row.districtName || row.postAddress ? (row.provinceName + row.cityName + row.districtName + row.postAddress) : ''
    }
  }
}
</script>
<style module lang="less">

</style>
